import React, { useState } from 'react';
import quotationFile from '../../QUOTATION.docx';

const QuotationTab = ({ showToast }) => {
    const [downloading, setDownloading] = useState(false);

    const handleDownload = () => {
        setDownloading(true);
        try {
            // Create a temporary link element
            const link = document.createElement('a');
            link.href = quotationFile;
            link.download = 'QUOTATION.docx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            showToast('Quotation template downloaded successfully!', 'success');
        } catch (error) {
            console.error('Error downloading file:', error);
            showToast('Failed to download file. Please try again.', 'error');
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div className="quotation-tab">
            <div className="tab-header" style={{ textAlign: 'center', padding: '60px 20px' }}>
                <div style={{ 
                    maxWidth: '700px', 
                    margin: '0 auto',
                    background: 'linear-gradient(135deg, #f0faf5 0%, #ffffff 100%)',
                    borderRadius: '20px',
                    padding: '50px 40px',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                    border: '1px solid #e0f2e9'
                }}>
                    {/* Icon */}
                    <div style={{
                        width: '80px',
                        height: '80px',
                        background: 'linear-gradient(135deg, #3e866b 0%, #2d6a52 100%)',
                        borderRadius: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 30px',
                        boxShadow: '0 8px 20px rgba(62, 134, 107, 0.3)'
                    }}>
                        <i className="fa-solid fa-file-word" style={{ fontSize: '36px', color: '#fff' }}></i>
                    </div>

                    {/* Title */}
                    <h2 style={{ 
                        fontSize: '32px', 
                        fontWeight: '800', 
                        color: '#1f3a2d',
                        marginBottom: '15px',
                        lineHeight: '1.2'
                    }}>
                        Quotation Template
                    </h2>

                    {/* Description */}
                    <p style={{ 
                        fontSize: '16px', 
                        color: '#4b5563',
                        marginBottom: '35px',
                        lineHeight: '1.6',
                        maxWidth: '500px',
                        margin: '0 auto 35px'
                    }}>
                        Download the professionally formatted Word document with Silver Sky Holidays letterhead. 
                        The template includes header and footer with company logo, contact details, and is fully editable.
                    </p>

                    {/* Features list */}
                    <div style={{
                        background: '#fff',
                        borderRadius: '12px',
                        padding: '25px',
                        marginBottom: '35px',
                        textAlign: 'left',
                        border: '1px solid #e5e7eb'
                    }}>
                        <div style={{ fontSize: '14px', fontWeight: '700', color: '#3e866b', marginBottom: '15px', textAlign: 'center' }}>
                            ✨ Template Features
                        </div>
                        {[
                            'Professional letterhead with company logo and branding',
                            'Header with company name, tagline, and contact details',
                            'Tri-color decorative line (green, gold, brown)',
                            'Pre-formatted quotation structure',
                            'Footer with company information',
                            'Fully editable in Microsoft Word'
                        ].map((feature, index) => (
                            <div key={index} style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '12px',
                                marginBottom: '12px',
                                fontSize: '14px',
                                color: '#374151'
                            }}>
                                <i className="fa-solid fa-circle-check" style={{ color: '#3e866b', marginTop: '3px', fontSize: '16px' }}></i>
                                <span>{feature}</span>
                            </div>
                        ))}
                    </div>

                    {/* Download Button */}
                    <button
                        onClick={handleDownload}
                        disabled={downloading}
                        style={{
                            padding: '16px 40px',
                            background: downloading ? '#9ca3af' : 'linear-gradient(135deg, #3e866b 0%, #2d6a52 100%)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '12px',
                            fontSize: '16px',
                            fontWeight: '700',
                            cursor: downloading ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '12px',
                            boxShadow: downloading ? 'none' : '0 8px 20px rgba(62, 134, 107, 0.3)',
                            transition: 'all 0.3s ease',
                            transform: downloading ? 'none' : 'translateY(0)'
                        }}
                        onMouseOver={(e) => {
                            if (!downloading) {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 12px 30px rgba(62, 134, 107, 0.4)';
                            }
                        }}
                        onMouseOut={(e) => {
                            if (!downloading) {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(62, 134, 107, 0.3)';
                            }
                        }}
                    >
                        {downloading ? (
                            <>
                                <i className="fa-solid fa-spinner fa-spin"></i>
                                Downloading...
                            </>
                        ) : (
                            <>
                                <i className="fa-solid fa-download"></i>
                                Download Quotation Template
                            </>
                        )}
                    </button>

                    {/* Info note */}
                    <p style={{
                        marginTop: '25px',
                        fontSize: '13px',
                        color: '#6b7280',
                        fontStyle: 'italic'
                    }}>
                        <i className="fa-solid fa-info-circle" style={{ marginRight: '6px' }}></i>
                        The downloaded file can be opened and edited in Microsoft Word or compatible applications.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default QuotationTab;
